import {SuperObjectModel} from '../core/definitions/super-object-model';

export const WIDE_MEDIA_DRAWER = 'min(100vw, 500px)';
export const NARROW_MEDIA_DRAWER = '150px';

// The drawer is wide when the media carousel has anything to show (images, video, audio,
// attachments, 3D models), and narrow when it only shows the "No media" message.
export function objectHasMedia(art: SuperObjectModel): boolean {
  return art?.$$mediaContainer?.mediaTypes?.length > 0;
}

export function mediaDrawerWidth(hasMedia: boolean): string {
  return hasMedia ? WIDE_MEDIA_DRAWER : NARROW_MEDIA_DRAWER;
}
